import LovrFire from '../lovrfire'
import firebase from 'firebase';
import {
    v4 as uuidv4
} from 'uuid';

import imageCompression from 'browser-image-compression';



export const getMentionList = async () => {
    const res = await LovrFire.firestore().collection('users').get()
    return res.docs;
}

export const getFollowers = (id, followersObserver) => {
    try {
        return LovrFire.firestore().collection('users').doc(id).collection('following').onSnapshot(followersObserver)
    } catch (e) {}
}

export const getFeeds = (observer) => {
    LovrFire.firestore().collection('posts').orderBy('time', 'desc')
        .onSnapshot(observer)
}

export const getUserData = async (id) => {
    const res = await LovrFire.firestore().collection('users').doc(id).get();
    return res.data();
}


export const getPostById = async (id, postObserver) => {
    return LovrFire.firestore().collection('posts').doc(id).onSnapshot(postObserver)
}

export const getUserImagePosts = async (id, imagePostObserver) => {
    return LovrFire.firestore().collection('posts').where("user", "==", id).where('type', '==', 1).orderBy('time', 'desc').onSnapshot(imagePostObserver)
}

export const getUserVideoPosts = async (id, imagePostObserver) => {
    return LovrFire.firestore().collection('posts').where("user", "==", id).where('type', '==', 2).orderBy('time', 'desc').onSnapshot(imagePostObserver)
}

export const getBookmarkedPosts = async (id, bookmarkObserver) => {
    try {
        return LovrFire.firestore().collection('posts').where(`whoBookmarked.${id}`, '==', true).orderBy('time', 'desc').onSnapshot(bookmarkObserver);
    } catch (e) {}
}

export const likePost = async (id) => {
    const postRef = LovrFire.firestore().collection('posts').doc(id);
    const uid = LovrFire.auth().currentUser.uid;

    return LovrFire.firestore().runTransaction(tx => {
        return tx.get(postRef).then(post => {
            if (!post.exists) {
                throw 'Error'
            }
            var newLikeCount = post.data().likesCount + 1
            const isLiked = Object.entries(post.data().whoLiked).filter(user => (user[1] == true && user[0] == uid));
            if (isLiked.length > 0) {
                return
            }
            tx.update(postRef, {
                likesCount: newLikeCount,
                [`whoLiked.${uid}`]: true
            });
        }).then(v => {
            return v
        }).catch(e => {})
    })
}

export const unlikePost = async (id) => {
    const postRef = LovrFire.firestore().collection('posts').doc(id);
    const uid = LovrFire.auth().currentUser.uid;


    return LovrFire.firestore().runTransaction(tx => {
        return tx.get(postRef).then(post => {
            if (!post.exists) {
                throw 'Error'
            }
            var newLikeCount = post.data().likesCount - 1
            const isLiked = Object.entries(post.data().whoLiked).filter(user => user[0] == uid || (user[1] == true && user[0] == uid));
            if (isLiked.length == 0 || isLiked.length == 1) {
                tx.update(postRef, {
                    likesCount: newLikeCount,
                    [`whoLiked.${uid}`]: false
                });
            }

        }).then(v => {
            return v
        }).catch(e => {})
    })
}

export const bookmarkPost = async (id) => {
    const postRef = LovrFire.firestore().collection('posts').doc(id);
    const uid = LovrFire.auth().currentUser.uid;

    return LovrFire.firestore().runTransaction(async tx => {
        return tx.get(postRef).then(post => {
            if (!post.exists) {
                throw 'Error'
            }
            tx.update(postRef, {
                [`whoBookmarked.${uid}`]: true
            });
        }).then(v => {
            return v
        }).catch(e => {})
    })
}

export const unBookmarkPost = async (id) => {
    const postRef = LovrFire.firestore().collection('posts').doc(id);
    const uid = LovrFire.auth().currentUser.uid;

    return LovrFire.firestore().runTransaction(async tx => {
        return tx.get(postRef).then(post => {
            if (!post.exists) {
                throw 'Error'
            }
            tx.update(postRef, {
                [`whoBookmarked.${uid}`]: false
            });
        }).then(v => {
            return v
        }).catch(e => {})
    })
}

export const makeComment = async (id, comment, commentParentID, mention) => {
    try {
        const uid = uuidv4().toString().replaceAll('-', '')
        var parent = commentParentID == null || commentParentID.trim() == "" ? id : commentParentID
        var whoCommentedInnerElement = {}
        whoCommentedInnerElement = {
            comment: comment,
            time: firebase.firestore.FieldValue.serverTimestamp(),
            user: LovrFire.auth().currentUser.uid,
            uid: uid,
            parent: parent,
            mention: mention,
            likesCount: 0,
            whoLiked: {}
        }
        await LovrFire.firestore().collection('posts').doc(id).update({
            [`whoCommented.${uid}`]: whoCommentedInnerElement
        });
        return 'Comment Added'
    } catch (e) {
        throw e
    }
}

export const likeComment = async (postId, id) => {
    try {
        const postRef = LovrFire.firestore().collection('posts').doc(postId);
        const uid = LovrFire.auth().currentUser.uid;

        return LovrFire.firestore().runTransaction(async tx => {
            return tx.get(postRef).then(post => {
                if (!post.exists) {
                    throw 'Error'
                }
                console.log(post.data()[`whoCommented`][id])
                var newLikeCount = post.data()['whoCommented'][id].likesCount + 1
                tx.update(postRef, {
                    [`whoCommented.${id}.whoLiked.${uid}`]: true,
                    [`whoCommented.${id}.likesCount`]: newLikeCount
                });
            }).then(v => {
                return v
            }).catch(e => {
                console.log(e)
            })
        })
    } catch (e) {

    }
}

export const unlikeComment = async (postId, id) => {
    try {
        const postRef = LovrFire.firestore().collection('posts').doc(postId);
        const uid = LovrFire.auth().currentUser.uid;

        return LovrFire.firestore().runTransaction(async tx => {
            return tx.get(postRef).then(post => {
                if (!post.exists) {
                    throw 'Error'
                }
                console.log(post.data()[`whoCommented`][id])
                var newLikeCount = post.data()['whoCommented'][id].likesCount - 1
                tx.update(postRef, {
                    [`whoCommented.${id}.whoLiked.${uid}`]: false,
                    [`whoCommented.${id}.likesCount`]: newLikeCount
                });
            }).then(v => {
                return v
            }).catch(e => {
                console.log(e)
            })
        })
    } catch (e) {

    }
}

export const deleteComment = async (postId, commentId) => {
    try {
        await LovrFire.firestore().collection('posts').doc(postId)
            .update({
                [`whoCommented.${commentId}`]: firebase.firestore.FieldValue.delete()
            })
    } catch (e) {}
}

export const uploadPost = async (description, location, media, type, isPaid) => {
    const docId = LovrFire.firestore().collection('posts').doc().id
    const mediaRef = LovrFire.storage().ref(`/posts/${docId}`)
    const mediaRefThumb = LovrFire.storage().ref(`/posts/${docId}_512x512`)
    const placeHolderRef = LovrFire.storage().ref(`/posts/${docId}_placeholder`)


    var downloadURL = null;
    var thumbnailURL = null;
    var placeholderURL = null;

    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1080,
        useWebWorker: true
    }
    const thumbnailOptions = {
        maxSizeMB: .5,
        maxWidthOrHeight: 512,
        useWebWorker: true
    }

    const placeholderOptions = {
        maxSizeMB: .001,
        maxWidthOrHeight: 512,
        useWebWorker: true
    }
    const resMedia = await fetch(media);
    const blob = await resMedia.blob();
    if (type == 1) {
        const compressedFile = await imageCompression(blob, options);
        const compressedFileThumb = await imageCompression(blob, thumbnailOptions);
        const placeholderFile = await imageCompression(blob, placeholderOptions);

        await mediaRef.put(compressedFile);
        await mediaRefThumb.put(compressedFileThumb);
        await placeHolderRef.put(placeholderFile);

        downloadURL = await mediaRef.getDownloadURL()
        thumbnailURL = await mediaRefThumb.getDownloadURL()
        placeholderURL = await placeHolderRef.getDownloadURL()
    } else if (type == 2) {
        await mediaRef.put(media);
        downloadURL = await mediaRef.getDownloadURL()
        thumbnailURL = ''
        placeholderURL = ''
    }
    const res = await LovrFire.firestore().collection('posts').doc(docId).set({
        id: docId,
        body: description,
        type: type,
        media: downloadURL,
        thumbnail: thumbnailURL,
        placeholder: placeholderURL,
        commentsCount: 0,
        likesCount: 0,
        isPaid: isPaid,
        location: location,
        time: firebase.firestore.FieldValue.serverTimestamp(),
        user: LovrFire.auth().currentUser.uid,
        whoBookmarked: {},
        whoLiked: {},
        whoCommented: {}
    })
    return res;
}


export const deletePost = async (id) => {
    return await LovrFire.firestore().collection('posts').doc(id).delete()
}

export const relatedPosts = async (id) => {
    const posts = await LovrFire.firestore().collection('posts')
        .where('user', '==', id).orderBy('time', 'desc').limit(7).get()
    return posts.docs
}

export const uploadProfilePic = async (image) => {
    const docId = LovrFire.firestore().collection('users').doc().id
    const mediaRef = LovrFire.storage().ref(`/profilepic/${docId}`)
    const thumbnailMediaRef = LovrFire.storage().ref(`/profilepic/${docId}/_thumb`)

    var downloadURL = null;
    var thumbnailURL = null
    const options = {
        maxSizeMB: .6,
        maxWidthOrHeight: 256,
        useWebWorker: true
    }
    const placeholderOptions = {
        maxSizeMB: .001,
        maxWidthOrHeight: 128,
        useWebWorker: true
    }
    const resMedia = await fetch(image);
    const blob = await resMedia.blob();

    const compressedFile = await imageCompression(blob, options);
    const compressedPlaceholder = await imageCompression(blob, placeholderOptions);


    await mediaRef.put(compressedFile);
    await thumbnailMediaRef.put(compressedPlaceholder)
    downloadURL = await mediaRef.getDownloadURL()
    thumbnailURL = await thumbnailMediaRef.getDownloadURL()
    LovrFire.firestore().collection('users').doc(LovrFire.auth().currentUser.uid).update({
        image: downloadURL,
        thumbnail: thumbnailURL
    }).catch((err) => {
        console.log(err)
    }).then(() => {
        console.log("data updated");
    })
}



export const getSuggestedFollowers = async (id) => {
    try {
        let creators = [];
        const uid = id;
        const userExistingFollowersRef = LovrFire.firestore().collection('users').doc(uid).collection('following');
        const creatorRef = LovrFire.firestore().collection('users').where('isCreator', '==', true).orderBy('followersCount', 'desc').limit(5);
        const followedDocs = (await userExistingFollowersRef.get()).docs;
        const creatorProfiles = (await creatorRef.get()).docs;

        let flag = 0;
        for (var i = 0; i < creatorProfiles.length; i++) {
            flag = 0;
            for (var j = 0; j < followedDocs.length; j++) {
                if (creatorProfiles[i].data().id == followedDocs[j].data().uid || creatorProfiles[i].data().id == LovrFire.auth().currentUser.uid) {
                    flag = 1;
                }
            }
            if (flag == 0) {
                creators.push(creatorProfiles[i].data());
            }
        }
        return creators;
    } catch (e) {}
}